"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/es6/promise");
var qs_1 = require("qs");
var settings_1 = require("../settings");
var getEndpoint = function (endpoint, key) {
    if (key === void 0) { key = ''; }
    return !endpoint ? (settings_1.default.searchApiUrl + ("/" + key) + '/feedback') : endpoint;
};
var makeQuery = function (query) { return qs_1.stringify(__assign({}, query, { t_client: Date.now() })); };
var ImageRequest = function (data, endpoint) {
    return new Promise(function (resolve, reject) {
        var image = global.document.createElement('img');
        image.onload = resolve;
        image.onerror = resolve;
        image.src = getEndpoint(endpoint) + "?" + makeQuery(data);
    });
};
var BeaconRequest = function (data, endpoint) {
    return new Promise(function (resolve, reject) {
        var key = data.key, rest = __rest(data, ["key"]);
        global.navigator.sendBeacon(getEndpoint(endpoint, key), JSON.stringify(__assign({}, rest, { t_client: Date.now() })));
        resolve();
    });
};
exports.request = (function () {
    if (typeof global.navigator !== 'undefined' && global.navigator.sendBeacon)
        return BeaconRequest;
    if (typeof global.window !== 'undefined')
        return ImageRequest;
    if (!process.env.BROWSER) {
        return function (data, endpoint) {
            return new Promise(function (resolve, reject) {
                var http = require('http');
                http.get(getEndpoint(endpoint).replace('https', 'http') + "?" + makeQuery(data));
                resolve();
            });
        };
    }
    throw new Error('Can not determinate request type');
})();
//# sourceMappingURL=request.js.map